import React from 'react';
export function StatsSection() {
  return <section className="px-5 py-0 pb-10 max-w-[640px] mx-auto" data-id="element-271">
      <div className="bg-[var(--card)] rounded-2xl p-7 text-center" data-id="element-272">
        <div className="mb-5" data-id="element-273">
          <div className="text-[42px] font-black text-[var(--accent)]" data-id="element-274">
            +2,400
          </div>
          <div className="text-[var(--muted)] text-[15px] mt-1" data-id="element-275">
            Mujeres que lo usaron
          </div>
        </div>

        <div className="h-px bg-[var(--border)] my-5" data-id="element-276" />

        <div className="mb-5" data-id="element-277">
          <div className="text-[42px] font-black text-[var(--accent)]" data-id="element-278">94%</div>
          <div className="text-[var(--muted)] text-[15px] mt-1" data-id="element-279">
            Detectaron al menos 1 crítico
          </div>
        </div>

        <div className="h-px bg-[var(--border)] my-5" data-id="element-280" />

        <div data-id="element-281">
          <div className="text-[42px] font-black text-[var(--accent)]" data-id="element-282">
            3 citas
          </div>
          <div className="text-[var(--muted)] text-[15px] mt-1" data-id="element-283">
            Es todo lo que necesitas
          </div>
        </div>
      </div>
    </section>;
}